import freeLog from './freeLog.js';

((C) => {
  Object.assign(C, {
    freeLog
  });
})(window.C = window.C || {});
